import React, { useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId, getLatLng } from "react-google-places-autocomplete";

const LocationInput = ({ location, setLocation }) => {
  const handleSelect = async (place) => {
    try {
      const results = await geocodeByPlaceId(place.value.place_id);
      const latLng = await getLatLng(results[0]);

      const formattedLocation = {
        lat: latLng.lat,
        lng: latLng.lng,
        address: results[0].formatted_address,
      };

      setLocation(formattedLocation);
      console.log("=>location", formattedLocation);
    } catch (error) {
      console.error("Error fetching location details:", error);
    }
  };

  return (
    <div>
      <label className="block mb-2 font-semibold text-black text-xl md:text-3xl">
        Table Address
      </label>
      <GooglePlacesAutocomplete
        selectProps={{
          onChange: handleSelect,
          placeholder: "Search cafes, malls, etc...",
          className:
            "w-[18.5rem] md:w-full p-2 rounded-full mt-2 h-12 text-black",
        }}
        apiOptions={{
          componentRestrictions: { country: "IN" },
        }}
        autocompletionRequest={{
          types: ["establishment"], // Enables search for businesses like cafes, malls, etc.
          componentRestrictions: { country: "IN" },
          location: { lat: 12.9716, lng: 77.5946 }, // Bangalore coordinates
          radius: 50000, // Restrict search to 50km around Bangalore
        }}
      />
    </div>
  );
};

export default LocationInput;
